import { render, staticRenderFns } from "./siteAdminGroupList.vue?vue&type=template&id=2a803d14&scoped=true&"
import script from "./siteAdminGroupList.vue?vue&type=script&lang=babel&"
export * from "./siteAdminGroupList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a803d14",
  null
  
)

export default component.exports